<div class="scroll-to-top float-right" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button type="button" class="btn active" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <i class="fa fa-angle-up"></i>
    </button>
  </div>
